import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import * as actions from "../../../../app/actions/generalActions";
import { useObjectsUIContext } from "../../../../_metronic/layout/components/basePage/pages/ObjectsUIContext";
import { useFilterObjectsUIContext } from "../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext";
import { ObjectStatusCssClasses, ObjectStatusTitles } from "../../../../_metronic/layout/components/basePage/pages/ObjectsUIHelpers";
import { SelectObjectsField } from "../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField";


const selectedObjects = (entities, ids) => {
    const _objects = [];
    ids.forEach((id) => {
        const object = entities.find((el) => el.id === id);
        if (object) {
            _objects.push(object);
        }
    });
    return _objects;
};

export const TransferSettingPage = ({ show, onHide, currentState, api }) => {
    // Objects UI Context
    const objectsUIContext = useObjectsUIContext();
    // const filterUIContext = useFilterObjectsUIContext();

    const objectsUIProps = useMemo(() => {
        return {
            ids: objectsUIContext.ids,
            setIds: objectsUIContext.setIds,
            // queryParams: filterUIContext.queryParams,
        };
    }, [objectsUIContext]);
    // }, [objectsUIContext, filterUIContext]);

    // Objects Redux state
    const { objects, isLoading, name } = useSelector(
        (state) => ({
            objects: selectedObjects(currentState.entities, objectsUIProps.ids),
            isLoading: currentState.actionsLoading,
            name: currentState.name
        }),
        shallowEqual
    );

    const { groupState } = useSelector(
        (state) => ({ groupState: state["groups"] }),
        shallowEqual
    );
    const dispatch = useDispatch();
    useEffect(() => {
        if (objectsUIProps.ids || objectsUIProps.ids.length === 0) {
            onHide();
        }

        const query = {
            whereClause: "",
            whereClauseParameters: [

            ],
            orderClause: "id asc ",
            skipCount: 0,
            takeCount: 1000
        };
        dispatch(actions.fetchObjects("api/group", groupState.name, query));

    }, [objectsUIProps.ids]);



    const [transferType, setStatus] = useState(0);
    const [groupId, setGroupId] = useState();
    const [subGroupId, setSubGroupId] = useState();

    const { subGroupState } = useSelector(
        (state) => ({ subGroupState: state["subGroups"] }),
        shallowEqual
    );
    useEffect(() => {
        const query = {
            whereClause: "",
            whereClauseParameters: [

            ],
            orderClause: "id asc ",
            skipCount: 0,
            takeCount: 1000
        };

        if (groupId > 0) {
            query.whereClause = query.whereClause + "groupId=@0"
            query.whereClauseParameters.push(groupId)
        }
        else {
            query.whereClause = query.whereClause + "groupId!=@0"
            query.whereClauseParameters.push(0)
        }


        dispatch(actions.fetchObjects("api/subgroup", subGroupState.name, query));
    }, [groupId, dispatch]);


    const transferSetting = () => {
        // dispatch(actions.updateObjectsStatus(api, name, objectsUIProps.ids, isDeleted)).then(
        //     () => {

        //         dispatch(actions.fetchObjects(api, name, objectsUIProps.queryParams)).then(
        //             () => {
        //                 objectsUIProps.setIds([]);
        //                 onHide();
        //                
        //             }
        //         );
        //     }
        // );
    };

    const intl = useIntl();
    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-sm">
                    <FormattedMessage id="انتقال تنظیمات به زیرگروه های انتخاب شده" />
                </Modal.Title>

            </Modal.Header>
            <Modal.Body className="overlay overlay-block cursor-default">
                {isLoading && (
                    <div className="overlay-layer bg-transparent">
                        <div className="spinner spinner-lg spinner-warning" />
                    </div>
                )}
                <div className="list-timeline list-timeline-skin-light padding-30">
                    <div className="list-timeline-items">
                        {objects.map((object) => (
                            <div className="list-timeline-item mb-3" key={object.id}>
                                <span className="list-timeline-text">
                                    <span
                                        className={`label label-lg label-light-${ObjectStatusCssClasses[+object.isDeleted]
                                            } label-inline`}
                                        style={{ width: "60px" }}
                                    >
                                        {object.id}
                                    </span>{" "}
                                    <span className="ml-5">
                                        {object.groupTitle} - {object.title}
                                    </span>
                                </span>
                            </div>
                        ))}
                    </div>
                </div>


            </Modal.Body>
            <Modal.Footer className="form">
                <div className="form-group">
                    <label>گروه مبدا</label>
                    <select
                        className={`form-control`}
                        value={groupId}
                        onChange={(e) => setGroupId(+e.target.value)}
                    >
                        {groupState.entities && groupState.entities.map((object) => (
                            <option key={object.id} value={object.id}> {object.title}</option>
                        ))}

                    </select>
                </div>
                <div className="form-group">
                    <label>زیرگروه مبدا</label>
                    <select
                        className={`form-control`}
                        value={subGroupId}
                        onChange={(e) => setSubGroupId(+e.target.value)}
                    >
                        {subGroupState.entities &&
                            <option key={0} value={0}>{intl.formatMessage({ id: "SELECT.ALL" })}</option>
                        }
                        {subGroupState.entities && subGroupState.entities.map((object) => (
                            <option key={object.id} value={object.id}> {object.groupTitle} - {object.title}</option>
                        ))}

                    </select>
                </div>
                <div className="form-group">
                    <label>نوع تنظیمات</label>
                    <select
                        className={`form-control`}
                        value={transferType}
                        onChange={(e) => setStatus(+e.target.value)}
                    >
                        <option value="0"> {intl.formatMessage({ id: "MODULES.GENERAL.STATUSALL" })}</option>
                        <option value="1"> {intl.formatMessage({ id: "ASID.SETTING.ATTENDANCE" })}</option>
                        <option value="2"> {intl.formatMessage({ id: "ASID.SETTING.CULLINAN" })}</option>
                        <option value="3"> {intl.formatMessage({ id: "ASID.SETTING.SPORT" })}</option>
                        <option value="4"> {intl.formatMessage({ id: "ASID.SETTING.DORMITORY" })}</option>
                    </select>
                </div>

                <div className="form-group">
                    <button
                        type="button"
                        onClick={onHide}
                        className="btn btn-light btn-elevate"
                    >
                        <FormattedMessage id="BUTTON.CANCEL" />
                    </button>
                    <> </>
                    <button
                        type="button"
                        onClick={transferSetting}
                        className="btn btn-primary btn-elevate"
                    >
                        <FormattedMessage id="BUTTON.OK" />
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
